import { type ReactNode } from "react";
import { type WithTranslation } from "react-i18next";
import DownloadItemBlock from "~/common/components/print/DownloadItemBlock";
import Parameter from "~/common/components/Parameter";
import { downloadFile } from "~/common/utils/ApiHelper";
import Tracker from "~/domains/orders/components/Tracker";
import { type OrderLineItemData } from "~/domains/orders/types/modelsV2";
import { DownloadContentButton } from "~/features/orders/quoteList/components/QuoteListTable/DownloadContentButton";

interface GridDataItem {
  label: ReactNode;
  value: JSX.Element | string | undefined;
}

export function getStatusData(t: WithTranslation["t"], entry: OrderLineItemData) {
  if (!entry.invoiceData) {
    return [];
  }

  const gridData: [GridDataItem[]] = [
    [
      {
        label: t("quoteDetailsPage.summary.invoiceNumber"),
        value: (
          <DownloadItemBlock
            data={entry.invoiceData}
            className={"mt-1 no-secondary-spacing"}
          />
        ),
      },
      {
        label: t("quoteDetailsPage.summary.invoiceDate"),
        value: entry.invoiceData.invoiceDate,
      },
    ],
  ];

  if (
    entry.invoiceData.trackingNo !== "-" ||
    (entry.invoiceData.shippingPartnerName &&
      entry.invoiceData.shippingPartnerName !== "-" &&
      entry.invoiceData.shippingPartnerName !== "") ||
    (entry.invoiceData.shippingPartnerId &&
      entry.invoiceData.shippingPartnerId !== "-" &&
      entry.invoiceData.shippingPartnerId !== "")
  ) {
    gridData[0].push({
      label: t("quoteDetailsPage.summary.shipmentReference"),
      value: <Tracker data={entry.invoiceData} />,
    });
  }

  if (entry.invoiceData.deliveryNoteNumber && entry.invoiceData.deliveryNoteUrl) {
    gridData[0].push({
      label: "",
      value: (
        <Parameter label={t("orderListPage.deliveryNote")}>
          <DownloadContentButton
            isLoading={false}
            label={entry.invoiceData.deliveryNoteNumber}
            labelHover={t("orderListPage.downloadDeliveryNote")}
            onClick={() =>
              downloadFile(
                `${entry.invoiceData?.deliveryNoteUrl}?id=${entry.invoiceData?.deliveryNoteNumber}&type=DELNOTE`,
              )
            }
          />
        </Parameter>
      ),
    });
  }

  return gridData;
}
